import './ContextMenuRowDivider.scss';

function ContextMenuRowDivider() {
  return <div className="ContextMenuRowDivider" />;
}

export default ContextMenuRowDivider;
